module.exports = __webpack_public_path__ + "img/6.4e956e04.png";